import { useEffect, useState } from 'react';
import { fetchClinic, fetchClinics } from '../../providers/clinics';
import { Select, Input, Label, Field } from '../Field';
import ImageUploader from '../ImageUploader';

function GeneralTab({ professional, setProfessional, showClinic = true, t }) {
    const [selectedSpecialties, setSelectedSpecialties] = useState([]);
    const [clinics, setClinics] = useState([]);
    const [clinic, setClinic] = useState(null);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setProfessional({ ...professional, [name]: value });
    };

    const changeClinicHandler = async (e) => {
        setClinic(await fetchClinic(e.target.value));
    };

    const changeSpecialtyHandler = (e) => {
        const { value, checked } = e.target;
        setSelectedSpecialties((prev) => (checked ? [...prev, parseInt(value)] : [...prev].filter((id) => id != value)));
    };

    useEffect(() => {
        if (professional.clinic_id) {
            fetchClinic(professional.clinic_id).then(setClinic);
        } else {
            fetchClinics().then(setClinics);
        }
    }, [professional.clinic_id]);

    useEffect(() => {
        setSelectedSpecialties((professional.specialties || []).map(({ id }) => id));
    }, [professional.specialties]);

    return (
        <div className="space-y-2">
            <Field>
                <Label>{t('logo')}</Label>
                <ImageUploader name="photo" current={professional?.photo} />
            </Field>

            <Field>
                <Label>
                    <span>{t('title')}</span>
                    <Select
                        name="title"
                        options={[
                            { id: 'Dr.', name: 'Dr.' },
                            { id: 'Dr.ª', name: 'Dr.ª' },
                            { id: 'Prof.', name: 'Prof.' },
                            { id: 'Prof.ª', name: 'Prof.ª' },
                            { id: 'Prof. Dr.', name: 'Prof. Dr.' },
                            { id: 'Prof.ª Dr.ª', name: 'Prof.ª Dr.ª' },
                            { id: 'Terapeuta', name: 'Terapeuta' },
                            { id: 'Enf.', name: 'Enf.' },
                            { id: 'Enf.ª', name: 'Enf.ª' },
                        ]}
                        value={professional.title || ''}
                        onChange={changeHandler}
                    ></Select>
                </Label>
            </Field>

            <Field>
                <Label>
                    <span>{t('name')}</span>
                    <Input type="text" name="name" value={professional.name || ''} onChange={changeHandler} />
                </Label>
            </Field>

            {showClinic && (
                <Field>
                    <Label>
                        <span>{t('clinic')}</span>
                        {professional.clinic_id ? (
                            <Input type="text" defaultValue={clinic?.name || ''} disabled />
                        ) : (
                            <Select name="clinic_id" value={clinic?.id} onChange={changeClinicHandler} options={clinics} disabled={!clinics.length} />
                        )}
                    </Label>
                </Field>
            )}

            {clinic && (
                <Field>
                    <Label>{t('specialties')}</Label>
                    {selectedSpecialties.length == 0 && <input type="hidden" name="specialties[]" />}
                    <ul className="px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm columns-1 sm:columns-2 lg:columns-4">
                        {clinic.specialties.map(({ id, name }) => (
                            <li key={id} className="py-1 break-inside-avoid-column">
                                <Label>
                                    <div className="inline-flex items-center gap-2">
                                        <Input type="checkbox" name="specialties[]" value={id} checked={selectedSpecialties.includes(id)} onChange={changeSpecialtyHandler} />
                                        <span className="font-normal">{name}</span>
                                    </div>
                                </Label>
                            </li>
                        ))}
                    </ul>
                </Field>
            )}
        </div>
    );
}

export default GeneralTab;
